import { render, staticRenderFns } from "./BriefingIssue.vue?vue&type=template&id=5b112b0e&scoped=true"
import script from "./BriefingIssue.vue?vue&type=script&lang=js"
export * from "./BriefingIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b112b0e",
  null
  
)

export default component.exports